import { render, staticRenderFns } from "./AtmRewardBanner.vue?vue&type=template&id=2f4933b7&scoped=true&"
import script from "./AtmRewardBanner.vue?vue&type=script&lang=js&"
export * from "./AtmRewardBanner.vue?vue&type=script&lang=js&"
import style0 from "./AtmRewardBanner.vue?vue&type=style&index=0&id=2f4933b7&lang=scss&scoped=true&"
import style1 from "./AtmRewardBanner.vue?vue&type=style&index=1&id=2f4933b7&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4933b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f4933b7')) {
      api.createRecord('2f4933b7', component.options)
    } else {
      api.reload('2f4933b7', component.options)
    }
    module.hot.accept("./AtmRewardBanner.vue?vue&type=template&id=2f4933b7&scoped=true&", function () {
      api.rerender('2f4933b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/atm/components/cards/AtmRewardBanner.vue"
export default component.exports